export const actionType = Object.freeze({
  NONE: 0,
  REQUIREMENT: 1,
  MOREINFO: 2,
  MULTI: 3,
  GOTO: 4,
});
